<template>
  <div class="email-table">
    <div class="table-top clearfix">
      <a-button
        type="primary"
        @click="creteEmail"
      >
        创建邮件
      </a-button>
      <div class="right fr">
        清单：
        <a-select
          v-model="contactid"
          @change="handleChange"
        >
          <a-select-option
            :value="0"
          >
            全部
          </a-select-option>
          <a-select-option
            v-for="option in contactNames"
            :key="option.id"
            :value="option.id"
          >
            {{ option.name }}
          </a-select-option>
        </a-select>
      </div>
    </div>
    <a-table
      v-if="!loading"
      row-key="id"
      :columns="columns"
      :data-source="listDatas"
      :pagination="false"
      :locale="{
        'emptyText': '暂无数据'
      }"
      :custom-row="customRow"
      @change="handleTableChange"
    >
      <template
        slot="name"
        slot-scope="text, record"
      >
        <p>
          {{ text }}
        </p>
        <p
          v-if="record.auto === 1"
          class="fs-gray999"
        >
          自动触发
        </p>
        <p
          v-else-if="record.contactname"
          class="fs-gray999"
        >
          {{ record.contactname }}（{{ record.contactnum }}）
        </p>
      </template>
      <em
        slot="filterIcon"
        class="th-filter-icon anticon anticon-filter ant-table-filter-icon ant-dropdown-trigger"
      >
        <i class="iconfont iconicon-test20" />
      </em>
      <div
        slot="status"
        slot-scope="text, record"
      >
        <div class="status-name fl">
          <p class="status">
            {{ getStatusName(text) }}
          </p>
          <p
            v-if="record.statustime"
            class="fs-gray"
          >
            {{ record.statustime }}
          </p>
        </div>
        <div
          v-if="text === 1"
          class="open-num fl"
        >
          <p>打开</p>
          <p class="fs-gray">
            {{ record.hover ? record.open : record.openrate }}
          </p>
        </div>
        <div
          v-if="text === 1"
          class="click-num fl"
        >
          <p>点击</p>
          <p class="fs-gray">
            {{ record.hover ? record.clicked : record.clickedrate }}
          </p>
        </div>
      </div>
      <template
        slot="edittime"
        slot-scope="text,record"
        class="time-item"
      >
        <p class="name">
          {{ record.truename }}
        </p>
        <p class="time fs-gray">
          {{ text }}
        </p>
      </template>
      <template
        slot="action"
        slot-scope="text,record"
      >
        <a-dropdown :trigger="['hover', 'click']">
          <a
            class="ant-dropdown-link more-btn fs-blue"
          >
            更多 <i class="iconfont iconicon-test19" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item v-if="record.status === 1 || record.status === 3 || record.status === 4">
              <router-link
                :to="{
                  name: 'SendReport',
                  query: {
                    emailid: record.id
                  }
                }"
                class="routelink"
              >
                查看报告
              </router-link>
            </a-menu-item>
            <a-menu-item
              v-if="record.status === 1 || (record.status === 3 && record.auto === 0)"
              @click="handleLook(record)"
            >
              查看邮件
            </a-menu-item>
            <a-menu-item v-if="record.status === -1 || record.status === 2 || ((record.status === 3 || record.status === 4) && record.auto)">
              <router-link
                :to="{
                  name: 'EdmEmailEdit',
                  query: {
                    emailid: record.id
                  }
                }"
                class="routelink"
              >
                编辑
              </router-link>
            </a-menu-item>
            <a-menu-item @click="handleCopy(record)">
              复制
            </a-menu-item>
            <a-menu-item v-if="!(record.status === 3 && !record.auto)">
              <a
                href="javascript:;"
                @click="handleDelete(record)"
              >删除</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </template>
    </a-table>
    <a-spin
      v-else
      class="spin-fixed-center"
    />
    <pagination
      v-if="listDatas && listDatas.length"
      ref="pagination"
      :pagination="pagination"
      @change="handlePage"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Pagination from '@/components/pc/Pagination'

export default {
  name: 'EmailTable',
  components: {
    Pagination
  },
  data () {
    return {
      contactid: 0
    }
  },

  computed: {
    ...mapState('edm/emailTable', ['statusOptions', 'contactNames', 'loading', 'listDatas', 'pagination', 'tableSort']),
    ...mapGetters('edm/emailTable', ['columns']),
    currentPage () {
      const { page = 1 } = this.$route.query
      return parseInt(page)
    },
    pageSize () {
      const { limit = 10 } = this.$route.query
      return parseInt(limit)
    }
  },

  watch: {
    $route (to, from) {
      this.pagination.currentPage = this.currentPage
      this.pagination.pageSize = this.pageSize
      this.getList()
    }
  },

  created () {
    this.pagination.currentPage = this.currentPage
    this.pagination.pageSize = this.pageSize

    this.fetchContactName()
    this.getList()
  },

  methods: {
    ...mapActions('edm/emailTable', ['fetchEmailList', 'fetchContactName', 'copyEmail', 'delEmail']),
    ...mapMutations('edm/emailTable', ['SET_TABLE_SORT']),

    creteEmail () {
      this.$router.push({
        name: 'EdmEmailEdit'
      })
    },
    handleChange (val) {
      this.contactid = val
      // this.getList()
      this.$router.push({
        query: {
          ...this.$route.query,
          page: 1,
          _t: new Date().getTime()
        }
      })
    },
    getList (params = {}) {
      let tableSort = this.tableSort
      tableSort.sortkey && Object.assign(params, { sortkey: tableSort.sortkey })
      tableSort.sorttype && Object.assign(params, { sort: tableSort.sorttype })
      tableSort.status && Object.assign(params, { status: tableSort.status })

      params.page = this.pagination.currentPage
      params.limit = this.pagination.pageSize
      params.contactid = this.contactid || ''

      this.fetchEmailList(params)
    },
    handleTableChange (pagination, filters, sorter) {
      console.log(filters, sorter)

      const { order, columnKey } = sorter
      let tableSort = {}
      if (sorter.order) {
        let sort = 0
        if (order === 'ascend') {
          sort = 1 // 正序
        } else if (order === 'descend') {
          sort = 2 // 倒序
        } else {
          sort = 0
        }

        tableSort.sortkey = columnKey
        tableSort.sorttype = sort
      }
      /* else {
        tableSort.sortkey = undefined
        sorter.sorttype = undefined
      } */

      if (filters) {
        let { status } = filters
        let newStatus = []
        status.map(filter => {
          this.statusOptions.forEach(option => {
            if (option.text === filter) {
              newStatus.push(option.key)
            }
          })
        })
        tableSort.status = newStatus
      }

      this.SET_TABLE_SORT({ tableSort, sorter, filters })

      this.$router.push({
        name: 'EmailList',
        query: {
          ...this.$route.query,
          page: 1,
          ...tableSort,
          _t: new Date().getTime()
        }
      })
    },
    handlePage (pagination) {
      this.pagination.currentPage = pagination.currentPage
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagination.currentPage,
          limit: pagination.pageSize,
          ...this.tableSort
        }
      })
    },
    customRow (record) {
      return {
        on: {
          mouseenter: (event) => {
            this.$set(record, 'hover', true)
          },
          mouseleave: (event) => {
            this.$set(record, 'hover', false)
          }
        }
      }
    },
    getStatusName (status) {
      let res = this.statusOptions.find(item => item.key === status)
      let name = res.text

      return name
    },
    handleLook (record) {
      this.$router.push({
        name: 'EdmEmailPrivew',
        query: {
          emailid: record.id
        }
      })
    },
    async handleCopy (record) {
      let chain = await this.copyEmail({ id: record.id })
      chain.onSuccess(res => {
        this.$router.push({
          query: {
            ...this.$route.query,
            page: 1,
            _t: new Date().getTime()
          }
        })
      })
    },
    /**
     * 删除邮件
     */
    async handleDelete (record) {
      this.$confirm({
        title: '删除邮件',
        content: '删除后不可恢复，是否继续？',
        closable: true,
        okText: '确定',
        okType: 'primary',
        cancelText: '取消',
        class: 'confirm-warn-modal',
        onOk: async () => {
          const chain = await this.delEmail({ id: record.id })
          chain
            .onSuccess(res => {
              this.getList()
            })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .ant-select {
    width: 240px;
  }
  .ant-table-wrapper {
    margin-top: 24px;
  }
  .time-item {
    font-size: 12px;
    position: absolute;
    top: 8px;
    line-height: 16px;
    .time {
      color: #999;
    }
  }
  .status-name {
    min-width: 160px;
  }
  .open-num, .click-num {
    width: 70px;
    text-align: center;
  }
  .more-btn {
    color: #5077aa;
  }
  .email-table ::v-deep {
    .ant-dropdown {
      .ant-checkbox-wrapper {
        margin-bottom: 0;
      }
      .ant-table-filter-dropdown-link {
        color: #5077aa;
      }
      .ant-dropdown-menu-item {
        margin: 0;
        padding-left: 20px;
      }
    }
    .ant-table-filter-dropdown {
      margin-top: 10px;
    }
    .ant-dropdown-menu-item-selected {
      background: none;
    }
    .ant-checkbox-wrapper {
      margin-right: 0;
    }
    .more-btn {
      font-size: 14px;
    }
    .ant-table-tbody > tr > td {
      padding: 9px 16px;
      font-size: 12px;
      p {
        line-height: 1;
      }
      p:nth-of-type(1) {
        margin-bottom: 6px;
      }
    }
  }
</style>
